import React from 'react';
import { motion } from 'framer-motion';
import { Download, Droplets, CalendarHeart } from 'lucide-react';
const steps = [{
  icon: Download,
  title: 'Paso 1',
  desc: 'Descarga el acceso al instante tras tu compra.'
}, {
  icon: Droplets,
  title: 'Paso 2',
  desc: 'Aplica la rutina con ingredientes accesibles.'
}, {
  icon: CalendarHeart,
  title: 'Paso 3',
  desc: 'Mantén constancia y disfruta de tu piel.'
}];
export function HowItWorks() {
  return <section className="py-24 bg-white" data-id="element-60">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-61">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-62">
          <h2 className="text-4xl font-medium text-brown mb-4" data-id="element-63">
            Cómo funciona
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-12 relative" data-id="element-64">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[1px] bg-beige -z-10" data-id="element-65" />

          {steps.map((step, i) => {
          const Icon = step.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: i * 0.2
          }} className="flex flex-col items-center text-center" data-id="element-66">
                <div className="w-24 h-24 bg-cream rounded-full flex items-center justify-center text-olive mb-6 shadow-sm border-4 border-white" data-id="element-67">
                  <Icon size={36} strokeWidth={1.5} data-id="element-68" />
                </div>
                <h3 className="text-xl font-medium text-brown mb-3" data-id="element-69">
                  {step.title}
                </h3>
                <p className="text-brown/70 font-light" data-id="element-70">{step.desc}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}